import React, { useState } from "react";
import { withRouter } from "react-router-dom";

import { baseRoute } from "@/config/roles";
import { Toolbar } from "@/components/Navigation/Toolbar/Toolbar";

import { GuidedVideoSection } from "./(guided-section)/GuidedVideoCallSection";

import "./VideoViewBase.styles.scss";

function VideoViewBaseComponent(props) {
  const { _callDetails, content, currentStep, header, workflow } = props;
  const [_showLauncher, setShowLauncher] = useState(false);

  const navbarConfiguration = {
    customRenderSection: [
      {
        componentProps: {
          currentStep: currentStep,
          showLauncher: () => setShowLauncher(true),
          workflow: workflow,
          ...props,
        },
        isComponent: true,
        render: GuidedVideoSection,
      },
    ],
  };

  let headerContent = (
    <div className="GuidedVideoCall__header flex-lg-row px-5 tw:static! tw:justify-center">
      {header}
    </div>
  );

  return (
    <div className="tw:fixed tw:inset-0 tw:z-overlay tw:size-full tw:overflow-x-hidden tw:overflow-y-auto tw:bg-fill-white">
      <Toolbar baseRoute={baseRoute} navbarConfiguration={navbarConfiguration} />

      {header && headerContent}
      {content}
    </div>
  );
}

export const VideoViewBase = withRouter(VideoViewBaseComponent);
